import { IDropdownItem } from "@ryde/shared";

import { LandingCompanyNameEnum } from "../enums";

export const LANDING_DESTINATION_STATIONS_IDS = {
  [LandingCompanyNameEnum.Clal]: 101002, // prod id is 101002
} as const;

export const NVIDIA_SHUTTLE_DESTINATION_STATIONS: IDropdownItem[] = [
  {
    value: 100878,
    label: "אנבידיה IBC",
  },
  {
    value: 100877,
    label: "אנבידיה בניין שלמה",
  },
];
